import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";
import type { Paywall, PaywallPrice } from "@circle-react/types";
import { defaultFormatPaywallCurrency } from "../constants";
import type { PriceScenariosProps } from "../types";
import { Title } from "./Title";

const getIntroFee = (price: PaywallPrice, paywall: Paywall) => {
  if (!price.upfront_payment_amount) {
    return null;
  }

  return {
    title: formatPaywallCurrencyAmount(
      paywall.currency,
      price.upfront_payment_amount,
      defaultFormatPaywallCurrency,
    ),
    suffix: t("intro_fee").toLowerCase(),
  };
};

export const IntroFee = ({ price, paywall }: PriceScenariosProps) => {
  const titleProps = getIntroFee(price, paywall);

  if (!titleProps) {
    return null;
  }

  return <Title {...titleProps} />;
};
